<div [ngClass]="{ 
    'mat-app-background' : !fillBackground,
    'mat-app-background-empty' : fillBackground }">
    <router-outlet></router-outlet>
    <app-a2hs></app-a2hs>
</div>